import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

import { useStores } from "../../../context/StoreContext";
import { ControlMode, Teleop2Controls } from "../../Teleop/Teleop2Controls";
import { IBaseModuleProps } from "../IBaseModuleProps";
import { Module } from "../Module";
import styles from "./index.scss";

export const ControlModule = observer((props: IBaseModuleProps) => {
    const [loading, setLoading] = useState<boolean>(true);

    const { operateStore } = useStores();
    const { session } = operateStore;
    const { streamType } = props;

    useEffect(() => {
        if (
            session &&
            session?.deviceConfiguration?.document?.teleop &&
            operateStore.armed
        ) {
            setLoading(false);
        }
    }, [
        session,
        session?.deviceConfiguration?.document?.teleop,
        operateStore.armed,
    ]);

    if (!session?.deviceConfiguration?.document?.teleop) {
        return null;
    }

    return (
        <Module
            {...props}
            preventContentDrag={true}
            type="controls"
            loading={loading}
            className={styles["control-module"]}
        >
            <Teleop2Controls
                sticky={false}
                session={session}
                configuration={session?.deviceConfiguration?.document?.teleop}
                controlMode={streamType as ControlMode}
            />
        </Module>
    );
});
